"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4878,5333,3108],{

/***/ 35333:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "commonConfig": function() { return /* binding */ commonConfig; }
/* harmony export */ });
var commonConfig = {
    maximumApplicableCards: 3,
    pdpVideosConfig: {
        enabled: true,
        productVideoOptions: {
            autoPlay: true,
            controls: false,
            loop: true,
            muted: true
        },
        videoPosition: 1
    },
    staticFeatures: {
        hideSoldOutColorsInStylesSelection: true,
        isPriceFilterSliderEnabled: true
    },
    validation: {
        address: {
            length: {
                max: 50,
                min: 0
            }
        },
        name: {
            length: {
                max: 50,
                min: 0
            }
        },
        phone: {
            length: {
                min: 1
            }
        }
    }
};


/***/ }),

/***/ 68192:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ commonForms; }
/* harmony export */ });
var commonForms = {
    registration: [
        [
            {
                name: "firstName",
                type: "input",
                required: true
            }
        ],
        [
            {
                name: "lastName",
                type: "input",
                required: true
            }
        ],
        [
            {
                name: "email",
                type: "input",
                inputType: "email",
                required: true
            }
        ],
        [
            {
                name: "password",
                type: "password",
                required: true
            }
        ],
        [
            {
                name: "emailList",
                type: "checkbox"
            }
        ],
        [
            {
                name: "tacOnCreateAccount",
                type: "terms-and-conditions"
            }
        ],
        [
            {
                name: "createAccount",
                type: "button",
                buttonType: "submit"
            }
        ], 
    ],
    registrationV2: [
        [
            {
                name: "firstName",
                type: "input",
                required: true
            }
        ],
        [
            {
                name: "lastName",
                type: "input",
                required: true
            }
        ],
        [
            {
                name: "email",
                type: "input",
                inputType: "email",
                required: true
            }
        ],
        [
            {
                name: "password",
                type: "password",
                required: true
            }
        ],
        [
            {
                name: "emailList",
                type: "checkbox"
            }
        ],
        [
            {
                name: "tacOnCreateAccount",
                type: "terms-and-conditions"
            }
        ],
        [
            {
                name: "createAccountV2",
                type: "button",
                buttonType: "submit"
            }
        ], 
    ],
    orderLookUpReturns: [
        [
            {
                name: "orderNo",
                type: "input",
                inputType: "text",
                required: true
            }, 
        ],
        [
            {
                name: "orderEmail",
                type: "input",
                inputType: "email",
                required: true
            }
        ],
        [
            {
                name: "returnsOrderExplainerModal",
                type: "text-to-modal",
                required: true
            }, 
        ],
        [
            {
                name: "submitButton",
                type: "button",
                buttonType: "submit"
            }, 
        ], 
    ]
};


/***/ }),

/***/ 24878:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "config": function() { return /* binding */ config_config; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(70169);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(79758);
// EXTERNAL MODULE: ./ui/forms/OrderLookUp/types.ts
var types = __webpack_require__(22498);
// EXTERNAL MODULE: ./sites/common/config.ts
var config = __webpack_require__(35333);
// EXTERNAL MODULE: ./sites/types.ts
var sites_types = __webpack_require__(81526);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(3204);
// EXTERNAL MODULE: ./sites/common/forms.ts
var common_forms = __webpack_require__(68192);
;// CONCATENATED MODULE: ./sites/jp/forms.ts




var addressForm = [
    [
        {
            name: "lastName",
            type: "input",
            required: true,
            preventStack: true
        },
        {
            name: "firstName",
            type: "input",
            required: true,
            preventStack: true
        }, 
    ],
    [
        {
            name: "lastNamePronunciation",
            type: "input",
            required: false,
            preventStack: true
        },
        {
            name: "firstNamePronunciation",
            type: "input",
            required: false,
            preventStack: true
        }, 
    ],
    [
        {
            name: "postalCode",
            type: "yubinbango-address-look-up",
            required: true
        },
        {
            name: "stateCode",
            type: "input",
            required: true
        }, 
    ],
    [
        {
            name: "city",
            type: "input",
            required: true
        }
    ],
    [
        {
            name: "address1",
            type: "input",
            required: true
        }
    ], 
];
var JPForms = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, common_forms/* commonForms */.C), {
    accountAddress: [
        [
            {
                name: "title",
                type: "input",
                required: true
            }
        ], 
    ].concat((0,_to_consumable_array/* default */.Z)(addressForm), [
        [
            {
                name: "phone",
                type: "input",
                inputType: "tel",
                required: true
            }
        ],
        [
            {
                name: "preferred",
                type: "checkbox"
            }
        ], 
    ]),
    checkoutAddress: (0,_to_consumable_array/* default */.Z)(addressForm).concat([
        [
            {
                name: "phone",
                type: "input",
                inputType: "tel",
                required: true
            }
        ],
        [
            {
                name: "addToAddressBook",
                type: "checkbox"
            }
        ], 
    ]),
    checkoutAmazonPayBillingAddress: [
        [
            {
                name: "lastName",
                type: "input",
                required: false,
                preventStack: true
            },
            {
                name: "firstName",
                type: "input",
                required: true,
                preventStack: true
            }, 
        ], 
    ].concat((0,_to_consumable_array/* default */.Z)(addressForm.slice(1)), [
        [
            {
                name: "phone",
                type: "input",
                inputType: "tel",
                required: true
            }
        ],
        [
            {
                name: "addToAddressBook",
                type: "checkbox"
            }
        ], 
    ]),
    checkoutAddressGuest: (0,_to_consumable_array/* default */.Z)(addressForm).concat([
        [
            {
                name: "phone",
                type: "input",
                inputType: "tel",
                required: true
            }
        ], 
    ]),
    checkoutContactInfo: [
        [
            {
                name: "email",
                type: "input",
                inputType: "email",
                required: true
            }
        ],
        [
            {
                name: "emailList",
                type: "checkbox"
            }
        ], 
    ],
    createAccountInConfirmation: [
        [
            {
                name: "password",
                type: "password",
                required: true
            }
        ],
        [
            {
                name: "passwordConfirmation",
                type: "password",
                required: true
            }
        ],
        [
            {
                name: "createAccountOnOrderConfirmation",
                type: "button",
                buttonType: "submit"
            },
            {
                name: "blank",
                type: "blank"
            }, 
        ], 
    ],
    registration: [
        [
            {
                name: "lastName",
                type: "input",
                required: true,
                preventStack: true
            },
            {
                name: "firstName",
                type: "input",
                required: true,
                preventStack: true
            }, 
        ],
        [
            {
                name: "lastNamePronunciation",
                type: "input",
                preventStack: true
            },
            {
                name: "firstNamePronunciation",
                type: "input",
                preventStack: true
            }, 
        ],
        [
            {
                name: "birthday",
                type: "birthday",
                required: true
            }
        ],
        [
            {
                name: "email",
                type: "input",
                inputType: "email",
                required: true
            }
        ],
        [
            {
                name: "password",
                type: "password",
                required: true
            }
        ],
        [
            {
                name: "emailList",
                type: "checkbox"
            }
        ],
        [
            {
                name: "tacOnCreateAccount",
                type: "terms-and-conditions"
            }
        ],
        [
            {
                name: "registerHere",
                type: "button",
                buttonType: "submit"
            }
        ], 
    ],
    registrationV2: [
        [
            {
                name: "lastName",
                type: "input",
                required: true,
                preventStack: true
            },
            {
                name: "firstName",
                type: "input",
                required: true,
                preventStack: true
            }, 
        ],
        [
            {
                name: "lastNamePronunciation",
                type: "input",
                preventStack: true
            },
            {
                name: "firstNamePronunciation",
                type: "input",
                preventStack: true
            }, 
        ],
        [
            {
                name: "birthday",
                type: "birthday",
                required: true
            }
        ],
        [
            {
                name: "email",
                type: "input",
                inputType: "email",
                required: true
            }
        ],
        [
            {
                name: "password",
                type: "password",
                required: true
            }
        ],
        [
            {
                name: "emailList",
                type: "checkbox"
            }
        ],
        [
            {
                name: "tacOnCreateAccount",
                type: "terms-and-conditions"
            }
        ],
        [
            {
                name: "registerHere",
                type: "button",
                buttonType: "submit"
            }
        ], 
    ],
    quickRegistration: [
        [
            {
                name: "lastName",
                type: "input",
                required: true
            }
        ],
        [
            {
                name: "firstName",
                type: "input",
                required: true
            }
        ],
        [
            {
                name: "email",
                type: "input",
                inputType: "email",
                required: true
            }
        ],
        [
            {
                name: "password",
                type: "password",
                required: true
            }
        ],
        [
            {
                name: "registrationHintText",
                type: "text-only"
            }
        ],
        [
            {
                name: "register",
                type: "button",
                buttonType: "submit"
            }
        ],
        [
            {
                name: "emailList",
                type: "checkbox"
            }
        ], 
    ],
    addPaymentMethod: [
        [
            {
                name: "holderNameAccount",
                type: "input",
                required: true
            }
        ],
        [
            {
                name: "cardNumber",
                type: "card-number",
                required: true
            }
        ],
        [
            {
                name: "expirationDate",
                type: "expiration-date",
                required: true
            },
            {
                name: "cvv",
                type: "cvv",
                required: true
            }, 
        ],
        [
            {
                name: "setStandardPayment",
                type: "checkbox"
            }
        ],
        [
            {
                name: "save",
                type: "button",
                buttonType: "submit"
            }
        ], 
    ],
    editProfile: [
        [
            {
                name: "lastName",
                type: "input",
                required: true
            }
        ],
        [
            {
                name: "firstName",
                type: "input",
                required: true
            }
        ],
        [
            {
                name: "lastNamePronunciation",
                type: "input",
                required: true
            }
        ],
        [
            {
                name: "firstNamePronunciation",
                type: "input",
                required: true
            }
        ],
        [
            {
                name: "gender",
                type: "input-radio"
            }
        ],
        [
            {
                name: "birthday",
                type: "birthday",
                required: true,
                hideSupportText: true
            }, 
        ],
        [
            {
                name: "save",
                type: "button",
                buttonType: "submit"
            }, 
        ], 
    ],
    orderLookUpReturns: [
        [
            {
                name: "orderNo",
                type: "input",
                inputType: "text",
                required: true
            }, 
        ],
        [
            {
                name: "orderEmail",
                type: "input",
                inputType: "email",
                required: true
            }
        ],
        [
            {
                name: "phone",
                type: "input",
                inputType: "tel",
                required: true
            }
        ],
        [
            {
                name: "returnsOrderExplainerModal",
                type: "text-to-modal",
                required: true
            }, 
        ],
        [
            {
                name: "submitButton",
                type: "button",
                buttonType: "submit"
            }, 
        ], 
    ],
    changePassword: [
        [
            {
                name: "currentPassword",
                type: "password",
                required: true
            }
        ],
        [
            {
                name: "newPassword",
                type: "password",
                required: true
            }
        ],
        [
            {
                name: "newPasswordConfirmation",
                type: "password",
                required: true
            }
        ],
        [
            {
                name: "save",
                type: "button",
                buttonType: "submit"
            }, 
        ], 
    ]
});

// EXTERNAL MODULE: ./sites/jp/fields.ts
var fields = __webpack_require__(3661);
;// CONCATENATED MODULE: ./sites/jp/states.ts
var jpStates = [
    {
        name: "北海道",
        value: 1
    },
    {
        name: "青森県",
        value: 2
    },
    {
        name: "岩手県",
        value: 3
    },
    {
        name: "宮城県",
        value: 4
    },
    {
        name: "秋田県",
        value: 5
    },
    {
        name: "山形県",
        value: 6
    },
    {
        name: "福島県",
        value: 7
    },
    {
        name: "茨城県",
        value: 8
    },
    {
        name: "栃木県",
        value: 9
    },
    {
        name: "群馬県",
        value: 10
    },
    {
        name: "埼玉県",
        value: 11
    },
    {
        name: "千葉県",
        value: 12
    },
    {
        name: "東京都",
        value: 13
    },
    {
        name: "神奈川県",
        value: 14
    },
    {
        name: "新潟県",
        value: 15
    },
    {
        name: "富山県",
        value: 16
    },
    {
        name: "石川県",
        value: 17
    },
    {
        name: "福井県",
        value: 18
    },
    {
        name: "山梨県",
        value: 19
    },
    {
        name: "長野県",
        value: 20
    },
    {
        name: "岐阜県",
        value: 21
    },
    {
        name: "静岡県",
        value: 22
    },
    {
        name: "愛知県",
        value: 23
    },
    {
        name: "三重県",
        value: 24
    },
    {
        name: "滋賀県",
        value: 25
    },
    {
        name: "京都府",
        value: 26
    },
    {
        name: "大阪府",
        value: 27
    },
    {
        name: "兵庫県",
        value: 28
    },
    {
        name: "奈良県",
        value: 29
    },
    {
        name: "和歌山県",
        value: 30
    },
    {
        name: "鳥取県",
        value: 31
    },
    {
        name: "島根県",
        value: 32
    },
    {
        name: "岡山県",
        value: 33
    },
    {
        name: "広島県",
        value: 34
    },
    {
        name: "山口県",
        value: 35
    },
    {
        name: "徳島県",
        value: 36
    },
    {
        name: "香川県",
        value: 37
    },
    {
        name: "愛媛県",
        value: 38
    },
    {
        name: "高知県",
        value: 39
    },
    {
        name: "福岡県",
        value: 40
    },
    {
        name: "佐賀県",
        value: 41
    },
    {
        name: "長崎県",
        value: 42
    },
    {
        name: "熊本県",
        value: 43
    },
    {
        name: "大分県",
        value: 44
    },
    {
        name: "宮崎県",
        value: 45
    },
    {
        name: "鹿児島県",
        value: 46
    },
    {
        name: "沖縄県",
        value: 47
    }, 
];

;// CONCATENATED MODULE: ./sites/jp/config.ts
/* provided dependency */ var process = __webpack_require__(27061);
// NOTE: please keep this JSON config sorted alphabetically to keep consistency between region config files









var config_config = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, config.commonConfig), {
    absoluteLinkBreadcrumb: true,
    additionalCtaClass: "px-[12px] text-[12px] !whitespace-nowrap",
    addressCountries: [
        {
            label: "Japan",
            value: constants/* SUPPORTED_COUNTRY.JP */.bM.JP
        }
    ],
    addressFormat: [
        [
            "lastName",
            "firstName"
        ],
        [
            "lastNamePronunciation",
            "firstNamePronunciation"
        ],
        [
            "postalCode",
            "stateCode"
        ],
        [
            "city",
            "address1",
            "address2"
        ], 
    ],
    addressFormatOneLiner: "@{lastName} @{firstName}, @{lastNamePronunciation} @{firstNamePronunciation} - @{postalCode} @{stateCode}, @{city} @{address1} @{address2}",
    addressSearch: {
        billing: [
            "JP"
        ],
        shipping: [
            "JP"
        ]
    },
    addressStates: {
        JP: jpStates
    },
    amazonPayButtonOptions: {
        color: "LightGray",
        size: "medium"
    },
    amazonPayScriptUrl: "https://static-fe.payments-amazon.com/checkout.js",
    amazonWidget: {
        countryCode: "fe",
        widgetSource: "lpa/js"
    },
    analytics: {
        releaseVersion: "Japan | ".concat(process.env.VERSION)
    },
    applePaySupportedNetworks: [],
    badgeIdsExcludedBySaleStatus: [
        "new",
        "exclusive",
        "worn_by"
    ],
    branchAnalyticsData: {
        agencyId: "1006963764752306474"
    },
    charactersNeededToSubmitSearch: 1,
    colors: {
        その他: "other",
        イエロー: "yellow",
        オレンジ: "orange",
        グリーン: "green",
        グレー: "gray",
        ゴールド: "gold",
        シルバー: "silver",
        パープル: "purple",
        ピンク: "pink",
        ブラウン: "brown",
        ブラック: "black",
        ブルー: "blue",
        ベージュ: "tan",
        ホワイト: "white",
        マルチカラー: "multi-colored",
        メタリック: "metallic",
        レッド: "red"
    },
    cookieConsent: {
        documentLanguage: true,
        provider: "OneTrust"
    },
    countryCode: "jp",
    countryName: "日本/Japan",
    currency: {
        code: "JPY",
        decimalsToDisplay: 0,
        symbol: "￥"
    },
    dateFormatWithWeekDay: [
        "YYYY",
        "TY",
        "MM",
        "TM",
        "DD",
        "TD",
        "(",
        "TW",
        ")"
    ],
    defaultPaymentMethod: constants/* PaymentMethod.CREDIT_CARD */.XL.CREDIT_CARD,
    deliveryTime: [
        {
            deliveryTimeCode: "0",
            deliveryTimeDisplayText: "指定なし(最短でのお届けとなります)"
        },
        {
            deliveryTimeCode: "1",
            deliveryTimeDisplayText: "午前中"
        },
        {
            deliveryTimeCode: "4",
            deliveryTimeDisplayText: "12:00 - 14:00"
        },
        {
            deliveryTimeCode: "5",
            deliveryTimeDisplayText: "14:00 - 16:00"
        },
        {
            deliveryTimeCode: "6",
            deliveryTimeDisplayText: "16:00 - 18:00"
        },
        {
            deliveryTimeCode: "7",
            deliveryTimeDisplayText: "18:00 - 20:00"
        },
        {
            deliveryTimeCode: "8",
            deliveryTimeDisplayText: "19:00 - 21:00"
        }, 
    ],
    fieldProps: fields/* JPFieldProps */.e,
    flag: "\uD83C\uDDEF\uD83C\uDDF5",
    forms: (0,_object_spread/* default */.Z)({}, JPForms),
    maxAgeCookiesExpires: constants/* MaxAgeExpiration.DAILY */.ho.DAILY,
    maxCountRecordKeeper: 100,
    miniCartItemType: sites_types/* ComponentType.SECONDARY */.r.SECONDARY,
    myAccountDashboardConfiguration: [
        {
            childOrder: [
                "membershipComponent",
                "extendedProfileComponent",
                "preferencesComponent",
                "addressBookComponent",
                "ambassadorComponent", 
            ],
            name: "leftColumn"
        },
        {
            childOrder: [
                "passwordComponent",
                "paymentInformationComponent",
                "orderHistoryComponent", 
            ],
            name: "rightColumn"
        }, 
    ],
    navCategoryMaxColumnCount: 6,
    newsletterProvider: "Cheetah",
    orderLookUpQuery: types/* OrderSearchOperationName.SearchOrderByEmailPhone */.G.SearchOrderByEmailPhone,
    orderedNewsletterSignupFormFields: {
        address: [
            "zip-code",
            "city",
            "address"
        ],
        name: [
            "lastName",
            "firstName"
        ]
    },
    orderedPaymentPartners: [
        "visa",
        "master",
        "JCB",
        "americanExpress",
        "diners",
        "amazonPay",
        "payPay", 
    ],
    paymentCreditCardErrors: {
        "100": "カード番号」を入力してください(半角英数)[エラーコード:100]",
        "101": "カード番号」を入力してください(半角英数)[エラーコード:101]",
        "102": "カード番号」を入力してください(半角英数)[エラーコード:102]",
        "110": "「有効期限」を入力してください[エラーコード:110]",
        "111": "「有効期限」を入力してください[エラーコード:111]",
        "112": "「有効期限」を入力してください[エラーコード:112]",
        "113": "「有効期限」を入力してください[エラーコード:113]",
        "121": "「セキュリティコード」を入力してください(3桁または4桁の半角数字)[エラーコード:121]",
        "122": "「セキュリティコード」を入力してください(3桁または4桁の半角数字)[エラーコード:122]",
        "131": "「カード名義人」を入力してください(半角英数50字以内)[エラーコード:131]",
        "132": "「カード名義人」を入力してください(半角英数50字以内)[エラーコード:132]",
        "42C010000": "決済処理に失敗しました。申し訳ございませんが、しばらく時間をあけて購入画面からやり直してください。",
        "42C030000": "決済処理に失敗しました。申し訳ございませんが、しばらく時間をあけて購入画面からやり直してください。",
        "42C120000": "決済処理に失敗しました。申し訳ございませんが、しばらく時間をあけて購入画面からやり直してください。",
        "42C130000": "決済処理に失敗しました。申し訳ございませんが、しばらく時間をあけて購入画面からやり直してください。",
        "42C140000": "決済処理に失敗しました。申し訳ございませんが、しばらく時間をあけて購入画面からやり直してください。",
        "42C150000": "決済処理に失敗しました。申し訳ございませんが、しばらく時間をあけて購入画面からやり直してください。",
        "42C500000": "決済処理に失敗しました。申し訳ございませんが、しばらく時間をあけて購入画面からやり直してください。",
        "42C510000": "決済処理に失敗しました。申し訳ございませんが、しばらく時間をあけて購入画面からやり直してください。",
        "42C530000": "決済処理に失敗しました。申し訳ございませんが、しばらく時間をあけて購入画面からやり直してください。",
        "42C540000": "決済処理に失敗しました。申し訳ございませんが、しばらく時間をあけて購入画面からやり直してください。",
        "42C550000": "決済処理に失敗しました。申し訳ございませんが、しばらく時間をあけて購入画面からやり直してください。",
        "42C560000": "決済処理に失敗しました。申し訳ございませんが、しばらく時間をあけて購入画面からやり直してください。",
        "42C570000": "決済処理に失敗しました。申し訳ございませんが、しばらく時間をあけて購入画面からやり直してください。",
        "42C580000": "決済処理に失敗しました。申し訳ございませんが、しばらく時間をあけて購入画面からやり直してください。",
        "42C600000": "決済処理に失敗しました。申し訳ございませんが、しばらく時間をあけて購入画面からやり直してください。",
        "42C700000": "決済処理に失敗しました。申し訳ございませんが、しばらく時間をあけて購入画面からやり直してください。",
        "42C710000": "決済処理に失敗しました。申し訳ございませんが、しばらく時間をあけて購入画面からやり直してください。",
        "42C720000": "決済処理に失敗しました。申し訳ございませんが、しばらく時間をあけて購入画面からやり直してください。",
        "42C730000": "決済処理に失敗しました。申し訳ございませんが、しばらく時間をあけて購入画面からやり直してください。",
        "42C740000": "決済処理に失敗しました。申し訳ございませんが、しばらく時間をあけて購入画面からやり直してください。",
        "42C750000": "決済処理に失敗しました。申し訳ございませんが、しばらく時間をあけて購入画面からやり直してください。",
        "42C760000": "決済処理に失敗しました。申し訳ございませんが、しばらく時間をあけて購入画面からやり直してください。",
        "42C770000": "決済処理に失敗しました。申し訳ございませんが、しばらく時間をあけて購入画面からやり直してください。",
        "42C780000": "決済処理に失敗しました。申し訳ございませんが、しばらく時間をあけて購入画面からやり直してください。",
        "42G020000": "カード残高が不足しているために、決済を完了する事が出来ませんでした。",
        "42G030000": "カード限度額を超えているために、決済を完了する事が出来ませ んでした。",
        "42G040000": "カード残高が不足しているために、決済を完了する事が出来ませんでした。",
        "42G050000": "カード限度額を超えているために、決済を完了する事が出来ませんでした。",
        "42G120000": "このカードでは取引をする事が出来ません。",
        "42G220000": "このカードでは取引をする事が出来ません。",
        "42G300000": "このカードでは取引をする事が出来ません。",
        "42G420000": "暗証番号が誤っていた為に、決済を完了する事が出来ませんでした。",
        "42G440000": "セキュリティーコードが誤っていた為に、決済を完了する事が出来ませんでした。",
        "42G450000": "セキュリティーコードが入力されていない為に、決済を完了する事が出来ませんでした。",
        "42G540000": "このカードでは取引をする事が出来ません。",
        "42G550000": "カード限度額を超えているために、決済を完了する事が出来ませんでした。",
        "42G560000": "このカードでは取引をする事が出来ません。",
        "42G600000": "このカードでは取引をする事が出来ません。",
        "42G610000": "このカードでは取引をする事が出来ません。",
        "42G650000": "カード番号に誤りがあるために、決済を完了する事が出来ませんでした。",
        "42G670000": "商品コードに誤りがあるために、決済を完了する事が出来ませんでした。",
        "42G680000": "金額に誤りがあるために、決済を完了する事が出来ませんでした。",
        "42G690000": "税送料に誤りがあるために、決済を完了する事が出来ませんでした。",
        "42G700000": "ボーナス回数に誤りがあるために、決済を完了する事が出来ませんでした。",
        "42G710000": "ボーナス月に誤りがあるために、決済を完了する事が出来ませんでした。",
        "42G720000": "ボーナス額に誤りがあるために、決済を完了する事が出来ませんでした。",
        "42G730000": "支払開始月に誤りがあるために、決済を完了する事が出来ませんでした。",
        "42G740000": "分割回数に誤りがあるために、決済を完了する事が出来ませんでした。",
        "42G750000": "分割金額に誤りがあるために、決済を完了する事が出来ませんでした。",
        "42G760000": "初回金額に誤りがあるために、決済を完了する事が出来ませんでした。",
        "42G770000": "業務区分に誤りがあるために、決済を完了する事が出来ませんでした。",
        "42G780000": "支払区分に誤りがあるために、決済を完了する事が出来ませんでした。",
        "42G790000": "照会区分に誤りがあるために、決済を完了する事が出来ませんでした。",
        "42G800000": "取消区分に誤りがあるために、決済を完了する事が出来ませんでした。",
        "42G810000": "取消取扱区分に誤りがあるために、決済を完了する事が出来ませんでした。",
        "42G830000": "有効期限に誤りがあるために、決済を完了する事が出来ませんでした。",
        "42G950000": "このカードでは取引をする事が出来ません。",
        "42G960000": "このカードでは取引をする事が出来ません。",
        "42G970000": "このカードでは取引をする事が出来ません。",
        "42G980000": "このカードでは取引をする事が出来ません。",
        "42G990000": "このカードでは取引をする事が出来ません。",
        "501": "申し訳ございません。システム処理が正しく完了しませんでした。もう一度試していただくか、カスタマーサービスまでご連絡ください。[エラーコード:501]",
        "502": "申し訳ございません。システム処理が正しく完了しませんでした。もう一度試していただくか、カスタマーサービスまでご連絡ください。[エラーコード:502]",
        "511": "申し訳ございません。システム処理が正しく完了しませんでした。もう一度試していただくか、カスタマーサービスまでご連絡ください。[エラーコード:511]",
        "512": "申し訳ございません。システム処理が正しく完了しませんでした。もう一度試していただくか、カスタマーサービスまでご連絡ください。[エラーコード:512]",
        "521": "申し訳ございません。システム処理が正しく完了しませんでした。もう一度試していただくか、カスタマーサービスまでご連絡ください。[エラーコード:521]",
        "522": "申し訳ございません。システム処理が正しく完了しませんでした。もう一度試していただくか、カスタマーサービスまでご連絡ください。[エラーコード:522]",
        "531": "申し訳ございません。システム処理が正しく完了しませんでした。もう一度試していただくか、カスタマーサービスまでご連絡ください。[エラーコード:531]",
        "541": "申し訳ございません。システム処理が正しく完了しませんでした。もう一度試していただくか、カスタマーサービスまでご連絡ください。[エラーコード:541]",
        "551": "申し訳ございません。システム処理が正しく完了しませんでした。もう一度試していただくか、カスタマーサービスまでご連絡ください。[エラーコード:551]",
        "552": "申し訳ございません。システム処理が正しく完了しませんでした。もう一度試していただくか、カスタマーサービスまでご連絡ください。[エラーコード:552]",
        "553": "申し訳ございません。システム処理が正しく完了しませんでした。もう一度試していただくか、カスタマーサービスまでご連絡ください。[エラーコード:553]",
        "901": "申し訳ございません。システム処理が正しく完了しませんでした。もう一度試していただくか、カスタマーサービスまでご連絡ください。[エラーコード:901]",
        E01230006: "カード登録連番に数字以外の文字が含まれています。",
        E01230009: "カード登録連番が最大登録可能数を超えています。",
        general: "申し訳ございませんが、何らかの理由によりご注文を完了することができませんでした。"
    },
    paymentMethodsMixedWithGiftCard: [
        constants/* PaymentMethod.AMBASSADOR_CARD */.XL.AMBASSADOR_CARD,
        constants/* PaymentMethod.SCHEME */.XL.SCHEME,
        constants/* PaymentMethod.ADYEN_PAYPAL */.XL.ADYEN_PAYPAL,
        constants/* PaymentMethod.AFTERPAY_TOUCH */.XL.AFTERPAY_TOUCH,
        constants/* PaymentMethod.ZIP_PAY */.XL.ZIP_PAY,
        constants/* PaymentMethod.KLARNA */.XL.KLARNA,
        constants/* PaymentMethod.KLARNA_ACCOUNT */.XL.KLARNA_ACCOUNT,
        constants/* PaymentMethod.ALIPAY */.XL.ALIPAY,
        constants/* PaymentMethod.WECHAT_PAY */.XL.WECHAT_PAY, 
    ],
    pdpLowInventoryThreshold: 5,
    pixleeId: {
        ja: "1456269"
    },
    plpShowDefaultSortOption: true,
    previewContentLanguage: "ja",
    priceInputMaxLength: 6,
    priceSliderInterval: 1000,
    pumaAppDownloadUrl: "https://app.puma.com/web-download-jp",
    region: "asia",
    regionCode: "JPN",
    resetSearchConditionsOptions: {
        isRouterScrollEnabled: true,
        showResetSearchConditionsButton: true
    },
    reviewFormModalSupportLinks: [
        {
            id: "1",
            link: "https://pumajapan.ugc.bazaarvoice.com/content/8206-ja_jp/termsandconditions.htm",
            popup: true,
            title: "termsAndConditions"
        },
        {
            id: "2",
            link: "/help/privacy-policy",
            newtab: true,
            title: "privacyPolicy"
        },
        {
            id: "3",
            link: "https://pumajapan.ugc.bazaarvoice.com/content/8206-ja_jp/guidelines.htm",
            popup: true,
            title: "reviewGuidelines"
        }, 
    ],
    savedCreditCardTemplate: [
        "saved",
        "new"
    ],
    scheduledArrivalDateFormat: [
        "TEXT",
        " ",
        "YYYY",
        "TY",
        " ",
        "MM",
        "TM",
        " ",
        "DD",
        "TD",
        " ",
        "(",
        "TW",
        ")", 
    ],
    searchEngineIndexableLanguages: [
        constants/* SUPPORTED_LANGUAGE.JA */.lF.JA
    ],
    searchSymbolsMinValue: 1,
    selectablePaymentMethods: [
        constants/* PaymentMethod.COD */.XL.COD,
        constants/* PaymentMethod.CREDIT_CARD */.XL.CREDIT_CARD,
        constants/* PaymentMethod.PAY_PAY */.XL.PAY_PAY,
        constants/* PaymentMethod.AMAZON_PAY_V2 */.XL.AMAZON_PAY_V2,
        constants/* PaymentMethod.AMBASSADOR_CARD */.XL.AMBASSADOR_CARD, 
    ],
    shoppingCartItemType: sites_types/* ComponentType.SECONDARY */.r.SECONDARY,
    socialMediaLinks: {
        instagram: "https://instagram.com/pumajapan/",
        twitter: "https://x.com/puma_JPN",
        youtube: "https://youtube.com/@PumaJPN"
    },
    staticFeatures: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, config.commonConfig.staticFeatures), {
        addAddressResultErrorDisabled: true,
        allowEditIncorrectSavedAddressCheckout: true,
        allowGuestAccessToOrderDetails: true,
        ambassadorCardsEnabled: true,
        canRemoveWishlistItemsFromPDP: true,
        checkoutHideShippingAndReturnsMessage: true,
        checkoutShowSaveCardCheckbox: true,
        displayPromoAppliedPromotion: true,
        displayPromoDiscountBreakdown: true,
        editPasswordResultErrorDisabled: true,
        enableStockStatusInPDP: true,
        hideBulletsListsPdp: true,
        hideCalloutMessage: true,
        hideEanColorCode: true,
        hideMyAccountSubtitle: true,
        hideNewsletterSignupButtonOnMobile: true,
        hidePaymentInformationOnAccountPage: true,
        hideTermsOnLoginForm: true,
        isGmoEnabled: true,
        mixedCart: true,
        pdpDisableReturns: true,
        pdpShowStockMessageBySFCCLogic: true,
        popoverLoginEnabled: true,
        popoverLoginEnabledJP: true,
        productFilterCollapsible: true,
        redirectToAccountDashboardAfterProfileUpdate: true,
        returnsOnOrderDetailsPage: true,
        returnsPageDisabled: true,
        reviewOrderOnCheckout: true,
        searchLocalImagesOnDropCalendar: true,
        searchLocalImagesOnProductComparison: true,
        setAutoCapitalizeOff: true,
        showAddAddressButtonInAccountDashboard: true,
        showAllPricesAtOnce: true,
        showBreadcrumbsOnOrderDetails: false,
        showCookieBanner: false,
        showCookieConsentLayer: true,
        showFinancialIncentivesLink: false,
        showFreeShippingCost: true,
        showGiftWithPurchaseModalInMobile: true,
        showHeaderSubHeaderProductDetail: false,
        showMetricAsDefault: true,
        showModifiedResetPassFormPopup: true,
        showNewsletterSignupOnOrderConfirmation: true,
        showOneFinalPriceOnPurchasedProduct: true,
        showPaymentPartnersInFooter: true,
        showPhoneInCheckout: false,
        showPriceDifference: false,
        showProductRecommenderOnError: true,
        showProductStoryKeywordTitle: true,
        showPromoExclusionMsgAboveProductDetails: true,
        showPromoExclusionMsgInGray: true,
        showPumaCard: true,
        showRefundInformationAtOrder: true,
        showSaleBadgeOnProductImageEnabled: true,
        showSearchFormOnError: true,
        showSearchResult: true,
        showSearchTipsOnError: true,
        showShippingDiscountInCheckout: true,
        showTitleTranslationInAccountOrderHistory: true,
        showWishlistIconBadgeOnDropdownMenu: true,
        singInInConfirmationForm: true,
        styleBazaarVoiceModal: true,
        translateToJapanese: true,
        useDefaultJapanChart: true,
        useNewPaymentForm: false,
        useProductSizeChart: true,
        useSFCCDividerForSEODescription: true,
        useStockInfoRedesign: true,
        useStockMessageFromResponse: true,
        useVariantPromotionExclusion: true
    }),
    supportedLocales: [
        "ja-jp"
    ],
    validation: {
        address: {
            amazonAddressMaxLength: 48,
            length: config.commonConfig.validation.address.length,
            line1: "^[\0-~\x80-ž’”　-〿぀-ゟ゠-ヿ＀-￯一-龯★-☆←-↕※]+$",
            line2: "^[\0-~\x80-ž’”　-〿぀-ゟ゠-ヿ＀-￯一-龯★-☆←-↕※]+$"
        },
        city: "^[\0-~\x80-ž’”　-〿぀-ゟ゠-ヿ＀-￯一-龯★-☆←-↕※]+$",
        email: "^[\\w-\\.\\%\\+]+@(([\\w-]{1,})+\\.)+[\\w-]{2,6}$",
        holderName: {
            regex: "^[a-zA-Z0-9.'\\s-]+$"
        },
        name: {
            length: config.commonConfig.validation.name.length,
            regex: "^([\0-~\x80-ž’”]|[　-〿぀-ゟ゠-ヿ＀-￯一-龯])+$"
        },
        password: "^(?=.*[a-zA-Z])(?=.*[0-9]).{8,255}$",
        phone: {
            length: {
                max: 30,
                min: config.commonConfig.validation.phone.length.min
            },
            regex: "^[\\+(/. 0-9 \\)-]+[ ]*((( |x|ext|ext.|extension|Ext|Ext.|Extension|#){1}[ ]?([0-9]){1,7}){0,1})$"
        },
        postalCode: {
            JP: "^([0-9]{3}-[0-9]{4})$|^([0-9]{7})$"
        },
        postalCodeMaxLength: 8
    }
});


/***/ }),

/***/ 22498:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ OrderSearchOperationName; }
/* harmony export */ });
var OrderSearchOperationName;
(function(OrderSearchOperationName) {
    OrderSearchOperationName["SearchOrderByEmail"] = "SearchOrderByEmail";
    OrderSearchOperationName["SearchOrderByEmailPhone"] = "SearchOrderByEmailPhone";
    OrderSearchOperationName["SearchOrderByEmailPostcode"] = "SearchOrderByEmailPostcode";
    OrderSearchOperationName["SearchOrderByPhone"] = "SearchOrderByPhone";
})(OrderSearchOperationName || (OrderSearchOperationName = {}));


/***/ })

}]);